module.exports = __webpack_public_path__ + "img/success_icon@3x.bc3cc4ad.png";